import importer from 'common/importer'
const Config = importer('Config')
const { oktaOauthReq: req } = importer('APIs', null)

const loginWithToken = ({
  refresh_token,
  code_verifier = Config.OKTA_CODE_VERIFIER || WEB_OKTA_CODE_VERIFIER,
  grant_type = 'refresh_token',
  client_id = Config.OKTA_CLIENT_ID || WEB_OKTA_CLIENT_ID,
  scope = Config.OKTA_SCOPE
}) => {
  const data = `grant_type=${grant_type}&client_id=${client_id}&refresh_token=${refresh_token}&code_verifier=${code_verifier}&scope=${scope}`
  const config = {
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      accept: 'application/json'
    }
  }
  return req.post('/token', data, config)
}

export default loginWithToken
